import type OverflowAutoStyles from './types';

/**
 * Web-only style.
 */
const overflowAuto: OverflowAutoStyles = {
    overflow: 'auto',
};

export default overflowAuto;
